import { styled } from 'theme';

export const Wrapper = styled('div')(({ theme }) => ({
  fontSize: theme?.size.text.md,
  lineHeight: '24px',
  color: theme?.color.typo.promo,
  backgroundColor: theme?.color.bg.primary,
  margin: '8px 24px',
}));
